<template>
    <div>
        <div class="font-bold fon-22 b-b-1-e3 pa-b-20">
            {{list.length}}条评论
        </div>
        <div class="ma-t-20">
            <el-input type="textarea" :rows="5" :placeholder="placeholder" v-model="value">
            </el-input>
        </div>
        <div class="ma-t-20 b-b-1-e3 pa-b-20 t-right">
            <div class="btn-support ma-t-10" @click="btnComment()">发表</div>
        </div>
        <div class="ma-t-30">
            <div v-for="(item,index) in list" :key="index" class="flex f-between ma-b-30">
                <img :src="item.HeadImage" alt="" srcset="" class="comment-img width10" />
                <div class="width90">
                    <div>
                        {{item.MemberName}}
                    </div>
                    <div class="c-666 fon-14 ma-t-10">
                        {{item.Time}}
                    </div>
                    <div class="ma-t-10">
                        <i class="iconfont icon-dianzan" v-if="item.IsAutoComment"></i> {{item.Comment}}
                    </div>
                </div>
            </div>
        </div>

        <div class="fy t-center">
            <el-pagination @current-change="handleCurrentChange" :hide-on-single-page="true"
                :current-page="pageIndex" :page-size="10" layout="prev, pager, next, jumper" :total="totals">
            </el-pagination>
        </div>

    </div>
</template>

<script>
import { postCommentAdd } from "../../api.js";

export default {
    name: 'comment',
    props: {
        list: {
            type: Array,
            default() {
                return []
            }
        },
        id: {
            type: String
        },
        totals:{
            type: Number,
            default() {
                return ''
            }
        },
        pageIndex:{
            type: Number,
            default() {
                return ''
            }
        },
    },
    data() {
        return {
            value: '',
            isLogin: false,
            placeholder: ''
        }
    },
    mounted() {
        this.isLogin = Boolean(localStorage.getItem("AccessToken"))
        if (this.isLogin) {
            this.placeholder = '请输入评论内容'
        } else {
            this.placeholder = '请先登录后发表评论'
        }
    },
    activated() {
        this.isLogin = Boolean(localStorage.getItem("AccessToken"))
        if (this.isLogin) {
            this.placeholder = '请输入评论内容'
        } else {
            this.placeholder = '请先登录后发表评论'
        }
    },
    methods: {
        //发表评论
        btnComment() {
            if (!this.isLogin) {
                this.$alert('您还未登录请先登录', '提示', {
                    confirmButtonText: '去登录',
                    cancelButtonText: '取消',
                    type: "warning"
                }).then(() => {
                    this.$router.push("/Login");
                }).catch(() => {
                });
                return
            }
            if (!this.value) {
                this.$message({
                    message: "请填写评论内容",
                    type: "warning",
                });
                return;
            }
            postCommentAdd({ Id: this.id, Comment: this.value }).then(() => {
                this.$message({
                    message: "评论成功",
                    type: "success",
                });
                this.value = ''
                this.$emit('changeComent',{pageIndex:1})
            })
        },
        // 当前页改变时触发
        handleCurrentChange(e) {
            let pageIndex = e;
            this.$emit('changeComent',{pageIndex:pageIndex})
        },
    }
}
</script>

<style lang="scss" scoped>
.btn-support {
    padding: 10px 70px;
    background: #fb004d;
    display: inline-block;
    color: #fff;
    cursor: pointer;

}

.comment-img {
    width: 50px;
    height: 50px;
    border-radius: 50px;
}
</style>